import PropTypes from "prop-types";
import styles from "./index.css";
import FulfilmentMarkup from "../FulfilmentMarkup";
import getFulfilmentIds from "../../../../getFulfilmentIds";
import getFulfilmentType, {
  FULFILMENT_TYPE
} from "../../../../getFulfilmentType";

const { CORE_PRIMARY } = FULFILMENT_TYPE;

const FulfilmentLabel = ({ seller, source, ...rest }) => {
  const { sellerId, sourceId } = getFulfilmentIds({ seller, source });
  const fulfilmentType = getFulfilmentType({ sellerId, sourceId });

  if (fulfilmentType === CORE_PRIMARY) {
    return null;
  }

  return (
    <div className={styles.fulfilmentLabel}>
      <FulfilmentMarkup source={source} seller={seller} {...rest} />
    </div>
  );
};

FulfilmentLabel.propTypes = {
  source: PropTypes.shape({
    description: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired
  }),
  seller: PropTypes.shape({
    id: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
  })
};

export default FulfilmentLabel;
